<template>
<div>
<div class="page-content">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="page-header">
            Terms Of Use
            <hr />
          </h1>
        </div>
        <div class="col-12">
          <h2>
              Coming Soon
          </h2>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'terms-of-use'
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";
.page-content {
  border-bottom: 3px $primary solid;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/TermsOfUse.vue